import {defaultConfig as defaultConfigFromDefault} from './defaultData/defaultConfig';

// Die elements-API (elements-a.de) wurde abgestellt. Die Kontaktanfrage laeuft
// ueber den sendMail-Endpunkt des Universal-Backends.
// Absolut, nicht relativ: relativ loest gegen die einbettende Seite auf und trifft
// lokal den Dev-Server (405). Der Backend-Endpunkt erlaubt CORS fuer alle Origins.
const SEND_MAIL_URL = 'https://universal.dasbad3.de/universalbackend/public/api/heaterconfig/sendMail';

export const defaultConfig = {
    ...defaultConfigFromDefault,
    watchListUrl: SEND_MAIL_URL,
    contactUrl: SEND_MAIL_URL,
};

export const ELEMENTS_SHOW_VERSION=true;
// Leer, weil die Bilder auf heizungskonfigurator.dasbad3.de direkt im Root
// liegen (/images, /page_images, /visuals). Der alte Unterordner
// /heizungsplanerapp existiert dort nicht (404).
export const IMAGE_ROOT_DIRECTORY="";
export const CONTACT_BY_FACHHANDWERKER_POSSIBLE=false;
export const SHOW_CONTACT_FORM = false;
// Produktliste ueberspringen: nach der letzten Frage direkt zum Kontaktformular.
// Noetig, weil der Produkt-Endpunkt der elements-API abgestellt ist.
export const SKIP_PRODUCT_RESULTS = true;